import classnames from 'classnames';
import React, { forwardRef, useCallback, memo } from 'react';
import { TStyle } from '../../common/types';
import styles from './StyleSelect.module.scss';

export interface StyleSelectProps {
    value?: TStyle;
    onChange?: (value: TStyle) => void;
    label?: string;
}

const defaultProps: StyleSelectProps = {
    value: 'normal',
    onChange: () => null,
    label: '',
};

const StyleSelect = forwardRef<HTMLButtonElement, StyleSelectProps>(
    ({ value, onChange, label }, ref): JSX.Element => {
        const setNormal = useCallback(() => onChange?.('normal'), [onChange]);
        const setAction = useCallback(() => onChange?.('action'), [onChange]);
        const setDark = useCallback(() => onChange?.('dark'), [onChange]);
        /* eslint-disable react/jsx-props-no-spreading */
        return (
            <div className={styles['style-select-container']}>
                <span className={styles['select-header']}>{label}</span>
                <div className={styles['options-container']}>
                    <div>
                        <button
                            className={classnames(styles['color-button'], styles['color-white'], {
                                [styles.active]: value === 'normal',
                            })}
                            type="button"
                            aria-label="normal"
                            onClick={setNormal}
                            ref={ref}
                        />
                    </div>
                    <div>
                        <button
                            className={classnames(styles['color-button'], styles['color-yellow'], {
                                [styles.active]: value === 'action',
                            })}
                            type="button"
                            aria-label="action"
                            onClick={setAction}
                            ref={ref}
                        />
                    </div>
                    <div>
                        <button
                            className={classnames(styles['color-button'], styles['color-black'], {
                                [styles.active]: value === 'dark',
                            })}
                            type="button"
                            aria-label="dark"
                            onClick={setDark}
                            ref={ref}
                        />
                    </div>
                </div>
            </div>
        );
        /* eslint-enable react/jsx-props-no-spreading */
    }
);

StyleSelect.defaultProps = defaultProps;

export default memo(StyleSelect);
